import React, { useState, useEffect } from "react";
import { AdminSidebar } from "../Sidebar/Sidebar";
import { AdminTopBar } from "../topbar/Topbar";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import BackButton from "../Goback/GoBack";
import TopImage from "../../common/TopImage";
import CustomInput from "../../../common/CustomInput";
import SuccessModal from "../../../common/SuccessModal";
import classroomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import * as Yup from "yup";

import { useCreateSchoolPayment } from "../../../../hooks/admin/InvoicePayments/useCreatePayment";

export const AgreementCreatePayment = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [inputLayout, setInputLayout] = useState(
    window.innerWidth < 576 ? "stacked" : "inline",
  );
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate();
  const { createPayment, loading, error } = useCreateSchoolPayment();

  useEffect(() => {
    const handleResize = () => {
      setInputLayout(window.innerWidth < 576 ? "stacked" : "inline");
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------------- initial values ---------------- */
  const initialValues = {
    invoiceNumber: "",
    amount: "",
    currency: "INR",
    payment_mode: "offline",
    payment_method: "",
    transaction_id: "",
    payment_status: "success",
    remarks: "",
  };

  /* ---------------- validation ---------------- */
  const validationSchema = Yup.object({
    invoiceNumber: Yup.string()
      .typeError("Invoice Number must be a number")
      .required("Invoice Number is required"),
    amount: Yup.number()
      .typeError("Amount must be a number")
      .required("Amount is required"),
    payment_method: Yup.string().required("Payment method is required"),
    transaction_id: Yup.string().when("payment_mode", {
      is: "online",
      then: (schema) => schema.required("Transaction ID is required"),
    }),
  });

  /* ---------------- submit ---------------- */
  const handleSubmit = async (values) => {
    const payload = {
      invoiceNumber: values.invoiceNumber,
      amount: Number(values.amount),
      currency: values.currency,
      payment_mode: values.payment_mode,
      payment_method: values.payment_method,
      transaction_id: values.transaction_id || null,
      payment_status: values.payment_status,
      remarks: values.remarks,
    };

    await createPayment(payload);
    setShowSuccessModal(true);
  };

  return (
    <div className="dashboardBody school-section">
      <AdminSidebar isSidebarCollapsed={isSidebarCollapsed} />

      <div className="container-fluid p-0">
        <AdminTopBar
          toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />

        <div className="teacher-bodycontent mb-4">
          <section className="container-fluid">
            <BackButton />
            <TopImage imageSrc={classroomImg} text="Create Payment" />

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values }) => (
                <Form className="mt-4">
                  <div className="school-card mb-4">
                    <h4 className="fw-bold mb-3">Payment Details</h4>
                    <hr />

                    <div className="row g-3">
                      {/* Invoice ID */}
                      <div className="col-md-12">
                        <CustomInput
                          label="Invoice Number"
                          name="invoiceNumber"
                          type="text"
                          placeholder="Enter Invoice Number"
                          layout={inputLayout}
                          labelWidth={{ desktop: "200px" }}
                        />
                      </div>

                      {/* Amount */}
                      <div className="col-md-12">
                        <CustomInput
                          label="Payment Amount"
                          name="amount"
                          type="number"
                          placeholder="Enter payment amount"
                          layout={inputLayout}
                          labelWidth={{ desktop: "200px" }}
                        />
                      </div>

                      {/* Currency */}
                      <div className="col-md-12">
                        <CustomInput
                          label="Currency"
                          name="currency"
                          type="select"
                          layout={inputLayout}
                          labelWidth={{ desktop: "200px" }}
                        >
                          <option value="INR">INR</option>
                          <option value="USD">USD</option>
                        </CustomInput>
                      </div>

                      {/* Payment Mode */}
                      <div className="col-md-12">
                        <div
                          className={`custom-input-group ${
                            inputLayout === "inline" ? "inline-layout" : ""
                          }`}
                          style={
                            inputLayout === "inline"
                              ? { "--label-width-desktop": "200px" }
                              : {}
                          }
                        >
                          <div className="label-container">
                            <label>Payment Mode *</label>
                          </div>

                          <div className="d-flex gap-4">
                            <label className="d-flex gap-2">
                              <Field
                                type="radio"
                                name="payment_mode"
                                value="offline"
                              />
                              Offline
                            </label>

                            {/* <label className="d-flex gap-2">
                              <Field
                                type="radio"
                                name="payment_mode"
                                value="offline"
                              />
                              Offline
                            </label> */}
                          </div>
                        </div>
                      </div>

                      {/* Payment Method */}
                      <div className="col-md-12">
                        <CustomInput
                          label="Payment Method"
                          name="payment_method"
                          type="select"
                          layout={inputLayout}
                          labelWidth={{ desktop: "200px" }}
                        >
                          <option value="">Select Method</option>
                          {values.payment_mode === "offline" ? (
                            <>
                              <option value="upi">UPI</option>
                              <option value="cheque">Cheque</option>
                              <option value="net_banking">Net Banking</option>
                              <option value="bank_transfer">
                                Bank Transfer
                              </option>
                              <option value="rtgs">RTGS</option>
                            </>
                          ) : (
                            <>
                              <option value="cash">Cash</option>
                              <option value="cheque">Cheque</option>
                              <option value="bank_transfer">
                                Bank Transfer
                              </option>
                            </>
                          )}
                        </CustomInput>
                      </div>

                      {/* Transaction ID */}
                      {values.payment_mode === "offline" && (
                        <div className="col-md-12">
                          <CustomInput
                            label="Transaction ID"
                            name="transaction_id"
                            type="text"
                            placeholder="Enter transaction ID"
                            layout={inputLayout}
                            labelWidth={{ desktop: "200px" }}
                          />
                        </div>
                      )}

                      {/* Status */}
                      {/* <div className="col-md-12">
                        <CustomInput
                          label="Payment Status"
                          name="payment_status"
                          type="select"
                          layout={inputLayout}
                          labelWidth={{ desktop: "200px" }}
                        >
                          <option value="success">Success</option>
                          <option value="pending">Pending</option>
                          <option value="failed">Failed</option>
                        </CustomInput>
                      </div> */}

                      {/* Remarks */}
                      <div className="col-md-12">
                        <CustomInput
                          label="Remarks"
                          name="remarks"
                          type="textarea"
                          placeholder="Optional notes"
                          layout={inputLayout}
                          labelWidth={{ desktop: "200px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {error && <div className="text-danger mb-3">{error}</div>}

                  <Button
                    type="submit"
                    className="custom-primary-button"
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Payment"}
                  </Button>
                </Form>
              )}
            </Formik>
          </section>
        </div>
      </div>

      {/* Success Modal */}
      <SuccessModal
        showModal={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        title="Payment Created Successfully"
        message="Payment has been successfully recorded."
        primaryButtonText="Payment List"
        secondaryButtonText="Close"
        onPrimaryClick={() => navigate("/school/agreement/payments")}
        onSecondaryClick={() => setShowSuccessModal(false)}
      />
    </div>
  );
};
